// extracted by mini-css-extract-plugin
export default {"semeia-profile-menu":"_semeia-profile-menu_or9Tne"};